
import React, { memo } from 'react';

import moment from 'moment';
import cx from 'classnames';
import memoizeOne from 'memoize-one';
import { Text } from '../../../../../ui-kit';
import StatusBar from './StatusBar';
import '../styles/_credits-overview.scss';












function getCreditText({ isUnlimited, total, balance }) {
  if (isUnlimited) return 'Unlimited';
  if (total === undefined) return balance;

  return `${balance} of ${total}`;
}

function CreditsBlock({
  title,
  balance,
  total,
  footerText,
  footerPrefix = '',
  footerPrefixColour = '',
  isUnlimited = false








}) {
  return (
    <div className="credits-overview__block">
      <Text heading5 noMargin className="credits-overview__block__header">{title}</Text>
      <Text heading3 prefixIcon={isUnlimited ? 'unlimited' : void 0}>
        {getCreditText({ isUnlimited, total, balance })}
      </Text>
      {!isUnlimited && total !== undefined ? <StatusBar balance={balance} total={total} /> : null}
      {footerText &&
      <div className="credits-overview__block__footer">
          <Text
          noMargin="bottom"
          label
          prefixIcon={footerPrefix}
          prefixIconColor={footerPrefixColour}
          className={`credits-overview__block__footer__text--${footerPrefix}`}>

            {footerText}
          </Text>
        </div>}

    </div>);

}

const getAvailableFooterProps = memoizeOne((monthlySubmissions) => {
  if (!monthlySubmissions || !monthlySubmissions.length) {return {};}

  const currentMonth = monthlySubmissions[monthlySubmissions.length - 1];
  const lastMonth = monthlySubmissions[monthlySubmissions.length - 2];
  const videoSubmissionsDiff = currentMonth.submissions - lastMonth.submissions;

  if (videoSubmissionsDiff > 0) {
    return {
      footerPrefix: 'positive',
      footerPrefixColour: 'monkey',
      footerText: `${Math.abs(videoSubmissionsDiff)} videos from last month`
    };
  }
  if (videoSubmissionsDiff < 0) {
    return {
      footerPrefix: 'negative',
      footerPrefixColour: 'redApple',
      footerText: `${Math.abs(videoSubmissionsDiff)} videos from last month`
    };
  }
  return {
    footerPrefix: 'partial',
    footerPrefixColour: 'russian',
    footerText: 'Same videos as last month'
  };
});

const getDaysBeforeExpiry = memoizeOne(() => {
  const currentDate = moment().date();
  const daysInCurrentMonth = moment().daysInMonth();

  return daysInCurrentMonth - currentDate + 1;
});

function CreditsOverview({
  isUnlimited,
  creditBalance,
  monthlySubmissions,
  size,
  className,
  children,
  subscriptionsV22 = false,
  hideBufferCredits = false,
  financeLedgerEnabled = false,
  financeCreditsRemaining
}) {
  if (!creditBalance) {return null;}

  if (financeLedgerEnabled) {
    const balance =
    typeof financeCreditsRemaining === 'number' ? financeCreditsRemaining : 0;
    return (
      <div
        className={cx(
          'credits-overview',
          { 'credits-overview--unlimited': isUnlimited },
          className
        )}>

        <div className="credits-overview__inner">
          <CreditsBlock
            title="Credits Remaining"
            balance={balance}
            isUnlimited={isUnlimited}
            footerText="Available" />

        </div>
        {children}
      </div>);

  }

  const isSmall = size.width < 400;
  const {
    balance,
    creditTotal,
    rolloverBalance,
    rolloverTotal,
    topUpCreditBalance = 0,
    bufferCreditsBalance = 0,
    bufferCreditsLimit = 0,
    recurringCreditBalance = 0
  } = creditBalance;

  // If small version then combine rollover with credits
  const balanceToDisplay = isSmall ? balance + rolloverBalance : balance;
  const totalToDisplay = isSmall ? creditTotal + rolloverTotal : creditTotal;

  return (
    <div
      className={cx(
        'credits-overview',
        { 'credits-overview--unlimited': isUnlimited },
        className
      )}>

      <div className="credits-overview__inner">
        <CreditsBlock
          title="Monthly Credits"
          balance={subscriptionsV22 ? recurringCreditBalance : balanceToDisplay}
          total={totalToDisplay}
          isUnlimited={isUnlimited}
          {...!subscriptionsV22 ? getAvailableFooterProps(monthlySubmissions) : {
            footerText: 'Credits that are available each month. Unused credits expire at the end of each month'
          }} />


        {subscriptionsV22 ?
        <CreditsBlock
          title="Flex Credits"
          balance={topUpCreditBalance}
          footerText="Credits that can be flexibly used anytime within your subscription" /> :

        null}

        {subscriptionsV22 && !hideBufferCredits ?
        <CreditsBlock
          title="Credit Advance Allowance"
          balance={bufferCreditsBalance}
          total={bufferCreditsLimit}
          footerText="Allowed credit usage past limits" /> :

        null}

        {!subscriptionsV22 &&
        !isUnlimited && !isSmall ?

        <CreditsBlock
          title="Rollover Credits"
          balance={rolloverBalance}
          total={rolloverTotal}
          footerText={`Expires in ${getDaysBeforeExpiry()} days`}
          {...getAvailableFooterProps(monthlySubmissions)} /> :


        null}

      </div>
      {children}
    </div>);

}

export default memo(CreditsOverview);